/**
 * @generated SignedSource<<03551eedef97211f8b0ff07ddf4f4b13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReorderProductInput = {
  navSectionId?: string | null;
  ordering: number;
  productId: string;
};
export type ProductsSidebarDragDropProvider_ReorderProductMutation$variables = {
  input: ReorderProductInput;
};
export type ProductsSidebarDragDropProvider_ReorderProductMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly navOrdering: number | null;
      readonly navSectionId: string | null;
    } | null;
  };
};
export type ProductsSidebarDragDropProvider_ReorderProductMutation = {
  response: ProductsSidebarDragDropProvider_ReorderProductMutation$data;
  variables: ProductsSidebarDragDropProvider_ReorderProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReorderProductResponse",
    "kind": "LinkedField",
    "name": "reorderProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "navSectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "navOrdering",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductsSidebarDragDropProvider_ReorderProductMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductsSidebarDragDropProvider_ReorderProductMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6d4bf663d7ea02ff06a7153e27c9f92",
    "id": null,
    "metadata": {},
    "name": "ProductsSidebarDragDropProvider_ReorderProductMutation",
    "operationKind": "mutation",
    "text": "mutation ProductsSidebarDragDropProvider_ReorderProductMutation(\n  $input: ReorderProductInput!\n) {\n  response: reorderProduct(input: $input) {\n    node {\n      id\n      navSectionId\n      navOrdering\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb9c411d264091bc849b4eab4c14bcbb";

export default node;
